import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import posed from "react-pose";

import Organization from "./Organization";
import Person from "./Person";
import MessageStep from "./MessageStep";
import { updateOrganization } from "../modules/actions";

export const steps = [
  {
    title: "Dein Projekt",
    component: Organization
  },
  {
    title: "Deine Person",
    component: Person
  },
  {
    title: "Deine Nachricht",
    component: MessageStep
  }
];

const Box = posed.div({
  enter: {
    x: 0,
    opacity: 1,
    delay: 20,
    transition: {
      x: { type: "spring", stiffness: 1000, damping: 40 },
      default: { duration: 350 }
    }
  },
  exit: {
    x: 20,
    opacity: 0,
    transition: { duration: 0 }
  }
});

const Wizard = ({ currentStep, boundUpdateOrganization }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(false);
    setTimeout(() => setVisible(true), 20);
    if (currentStep > 0) {
      document
        .getElementById("contact-form-app")
        .scrollIntoView({ block: "start", behavior: "smooth" });
    }
  }, [currentStep]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const orgRef = params.get("orgref");

    if (orgRef === "feuer") {
      console.log(orgRef);
      boundUpdateOrganization('type', 'club');
      boundUpdateOrganization('other_type', 'fire');
    }

    if (orgRef === "karneval") {
      console.log(orgRef);
      boundUpdateOrganization('type', 'club');
      boundUpdateOrganization('other_type', 'carneval');
    }
  }, []);

  const CurrentStepComponent = steps[currentStep].component;

  return (
    <>
      <Box className="box" pose={visible ? "enter" : "exit"}>
        <CurrentStepComponent />
      </Box>
    </>
  );
};

const mapStateToProps = state => ({
  currentStep: state.currentStep
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      boundUpdateOrganization: updateOrganization
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Wizard);
